import { lazy, Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CircleHelp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalDescription, ModalHeader, ModalTitle, ModalTrigger } from '@/components/ui/modal'
import { Skeleton } from '@/components/ui/loader'
import { ErrorBoundary } from '@/components/ErrorBoundary'

const HelpBrowser = lazy(() => import('./help-browser').then((module) => ({ default: module.HelpBrowser })))

/** Shared chrome entry. The article corpus is absent from app entry until opened. */
export function HelpLauncher({ expanded = false }: { expanded?: boolean }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalTrigger asChild>
        <Button variant="quiet" size={expanded ? 'row' : 'icon'} aria-label={t('help.open')} title={t('help.open')}
          >
          <CircleHelp className="size-5" aria-hidden="true" />
          {expanded && <span className="text-label">{t('help.open')}</span>}
        </Button>
      </ModalTrigger>
      <ModalContent size="lg">
        <ModalHeader>
          <div className="space-y-1"><ModalTitle>{t('help.open')}</ModalTitle><ModalDescription>{t('help.panelDescription')}</ModalDescription></div>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          {open && (
            <ErrorBoundary fallback={
              <div className="space-y-4" role="status">
                <p className="text-body text-[var(--text-secondary)]">{t('help.loadFailed')}</p>
                <Button variant="secondary" asChild>
                  <a href="/hjelp" target="_blank" rel="noopener noreferrer">{t('help.openCenterTab')}</a>
                </Button>
              </div>
            }>
              <Suspense fallback={<Skeleton className="h-48 w-full" />}><HelpBrowser /></Suspense>
            </ErrorBoundary>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
